module.exports = __webpack_public_path__ + "img/nordhms-logo.b2b0a764.png";